/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tables_Teams_User_EmailInputs */

const en_tables_teams_user_email = /** @type {(inputs: Tables_Teams_User_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`User Email`)
};

const de_tables_teams_user_email = /** @type {(inputs: Tables_Teams_User_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Benutzer Email`)
};

/**
* | output |
* | --- |
* | "User Email" |
*
* @param {Tables_Teams_User_EmailInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const tables_teams_user_email = /** @type {((inputs?: Tables_Teams_User_EmailInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tables_Teams_User_EmailInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tables_teams_user_email(inputs)
	return de_tables_teams_user_email(inputs)
});